import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Card, Modal, Box, TextField, Fade, CardContent, CardActions, Button, Typography, Avatar, CircularProgress } from '@mui/material';
import toast from 'react-hot-toast';
import LeadService from '../core/services/leadsService';
import { saveToken, saveUser } from '../core/services/authService';
import logoAgent from '../../public/assets/logo-agent.png';
// import { getToken, onMessage, getMessaging } from 'firebase/messaging';
// import Firebase, { auth, db, storage, messaging, analytics } from '../../public/firebaseConfigGuestCall';
import { logout } from '../core/services/authService';
import { LOGOUT } from '../core/store/slice/authSlice';
import { useDispatch } from 'react-redux';
import logoImage from '../../public/assets/Convrt_bg_remover.png';
import VideoCallModal from './VideoCallModal';
import branch from 'branch-sdk';
import heroBg from '../../public/assets/dashboard-image.jpeg';
import CancelIcon from '@mui/icons-material/Cancel';
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 300,
    maxWidth: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};
const UserProfileCard = () => {
    const { id } = useParams();
    const [isExpanded, setIsExpanded] = useState(false);
    const [getAgentData, setGetAgentData] = useState(null);
    const [success, setSuccess] = useState(null);
    const [loading, setLoading] = useState(true); // Loading state
    const [loadingButton, setLoadingButton] = useState(false);
    const [loadingSaving, setLoadingSaving] = useState(false);
    const [firebseToken, setFirebseToken] = useState('');
    const [callPayload, setCallPayload] = useState('');
    const [open, setOpen] = useState(false);
    const [variable, setVariable] = useState(null);
    const [isMobile, setIsMobile] = useState(false); // To detect device type
    const [isInitialized, setIsInitialized] = useState(false);
    const [receiverId, setReceiverId] = useState('');
    const [nameModal, setNameModal] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [agentDetails, setAgentDetails] = useState(null);

    const AgentData = async (id) => {
        setLoading(true); // Start loading
        try {
            const res = await LeadService.showReferralUser(id);
            if (res?.data?.success) {
                setGetAgentData(res?.data?.data);
                localStorage.clear();
                setSuccess(true);
            } else {
                setSuccess(false);
            }
        } catch (error) {
            // toast.error(error.message);
            setSuccess(false);
        } finally {
            setLoading(false); // Stop loading
        }
    };

    // useEffect(() => {
    //     // Detect if the device is mobile
    //     const userAgent = navigator.userAgent.toLowerCase();
    //     setIsMobile(/mobile|android|iphone|ipad/.test(userAgent));
    //     if (id) {
    //         AgentData(id);
    //     }
    // }, [id]);
    useEffect(() => {
        AgentData(id);  
    }, [id]);

    // const initializeBranch = () => {
    //     return new Promise((resolve, reject) => {
    //         try {
    //             branch.init('key_live_ftgZxlQr0QFEN1iJMA720fkjBrob9FFe', (err) => {
    //                 if (err) {
    //                     console.error('Branch initialization failed:', err);
    //                     reject(err);
    //                 } else {
    //                     setIsInitialized(true);
    //                     resolve();
    //                 }
    //             });
    //         } catch (error) {
    //             reject(error);
    //         }
    //     });
    // };

    // useEffect(() => {
    //     // Initialize Branch SDK when the component mounts
    //     initializeBranch()
    //         .then(() => {
    //             console.log('Branch SDK initialized');
    //         })
    //         .catch((error) => {
    //             console.error('Branch SDK initialization failed:', error);
    //             // Retry initialization if it fails
    //             setTimeout(() => initializeBranch(), 2000); // Retry after 2 seconds
    //         });
    // }, []);

    // const handleClickOpenApp = async () => {
    //     try {
    //         if (!isInitialized) {
    //             toast.error('Please refresh the page and try again.');
    //             return;
    //         }
    //         const linkData = {
    //             data: {
    //                 appType: 'guestCall', // Your app type
    //                 // id: getAgentData.id,
    //                 id: getAgentData.id.toString(),
    //                 $ios_url: 'https://apps.apple.com/us/app/iconnct-customer/id6499479156',
    //                 $android_url: 'https://play.google.com/store/apps/details?id=iconnct.customer.app',
    //                 $fallback_url: 'https://iconnct.com/',
    //             },
    //             channel: 'website',
    //             feature: 'deep-linking',
    //             stage: 'new-user',
    //             domain: 'your-custom-domain', // Optional: Replace with your custom domain if configured..
    //         };

    //         // Generate the deep link
    //         // const deepLink = await branch.link(linkData);
    //         branch.link(linkData, function (err, link) {
    //             console.log(link, 'test123232121');
    //             window.location.href = link; // Redirect the user to the generated deep linkk
    //         });

    //         // Log the link (for testing) and redirect the user
    //         // console.log('Deep Link:', deepLink.url);
    //         // window.location.href = deepLink.url; // Redirect the user to the generated deep link
    //     } catch (error) {
    //         console.error('Error creating deep link:', error.message);
    //     }
    // };

    const handleClickCall = async (receiver_id) => {
        try {
            let permissionsGranted = false;
    
            // Check if the mediaDevices API is supported
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
                alert("Camera and microphone access is not supported in this browser.Please open this link an other browser (e.g Chrome, Safari");
                return;
            }
    
            // Check if the device has a camera and microphone
            const checkDeviceAvailability = async () => {
                const devices = await navigator.mediaDevices.enumerateDevices();
                const hasVideoInput = devices.some((device) => device.kind === "videoinput");
                const hasAudioInput = devices.some((device) => device.kind === "audioinput");
    
                return { hasVideoInput, hasAudioInput };
            };
    
            // Request media permissions based on available devices
            const requestMediaPermissions = async (constraints) => {
                try {
                    await navigator.mediaDevices.getUserMedia(constraints);
                    return true; // Permissions granted
                } catch (error) {
                    if (error.name === "NotAllowedError" || error.name === "PermissionDeniedError") {
                        alert("Camera and microphone access is required to make a call. Please enable permissions in your browser settings to proceed.");
                        return false; // Permissions denied
                    }
                    throw error; // Re-throw unexpected errors
                }
            };
    
            // Check for available devices
            const { hasVideoInput, hasAudioInput } = await checkDeviceAvailability();
    
            if (!hasVideoInput && !hasAudioInput) {
                // If no devices are available, proceed directly to API call
                setLoadingButton(true);
                const res = await LeadService.checkAgentAvailability(receiver_id);
                if (res?.data?.success) {
                    toast.success(res.data.message);
                    setReceiverId(receiver_id);
                    setNameModal(true); // Open the modal on success
                }
                return; // Exit after the API call
            }
    
            // If devices are available, request permissions
            const constraints = { video: hasVideoInput, audio: hasAudioInput };
            while (!permissionsGranted) {
                permissionsGranted = await requestMediaPermissions(constraints);
                if (!permissionsGranted) {
                    // Exit if permissions are denied to avoid infinite loop
                    return;
                }
            }
    
            setLoadingButton(true);
    
            // Proceed with the API call if all permissions are granted
            const res = await LeadService.checkAgentAvailability(receiver_id);
            if (res?.data?.success) {
                toast.success(res.data.message);
                setReceiverId(receiver_id);
                setNameModal(true); // Open the modal on success
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoadingButton(false);
        }
    }; 
    // const handleClickCall = async (receiver_id) => {
    //     try {
    //         setLoadingButton(true);
    //         const res = await LeadService.checkAgentAvailability(receiver_id);
    //         if (res?.data?.success) {
    //             toast.success(res.data.message);
    //             setReceiverId(receiver_id);
    //             setNameModal(true); // Open the modal on success
    //         }
    //     } catch (error) {
    //         toast.error(error.message);
    //         setLoadingButton(false);
    //     } finally {
    //         setLoadingButton(false);
    //     }
    // };

    const handleCloseModal = async () => {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
                const tracks = stream.getTracks(); // Get all media tracks (audio and video)
                tracks.forEach(track => track.stop()); // Stop each track
                console.log("Camera and microphone streams stopped.");
            } catch (error) {
                console.error("Error stopping camera/microphone:", error.message);
            }
        }
        setNameModal(false);
        setFirstName('');
        setLastName('');
    }

    const HandleCreateAgentCustomer = async () => {
        if (!firstName.trim() || !lastName.trim()) {
            toast.error('Both fields are required.');
            return;
        }
        setLoadingSaving(true);
        try {
            const res = await LeadService.createAgentCustomer(receiverId);
            if (res?.data?.success) {
                setAgentDetails(res.data);
                setOpen(true); ///test 123
                setNameModal(false);
            }
        } catch (error) {
            console.error('Error creating agent customer:', error);
            toast.error(error.message);
        } finally {
            setLoadingSaving(false);
        }
    };

    // useEffect(() => {
    //     if ('serviceWorker' in navigator) {
    //         window.addEventListener('load', async () => {
    //             try {
    //                 const registration = await navigator.serviceWorker.register('/iconnctAdminPanel/Guest-Call-messaging-sw.js', {
    //                     scope: '/iconnctAdminPanel/',
    //                 });
    //                 console.log('Service Worker registered with scope:', registration.scope);
    //             } catch (error) {
    //                 console.error('Service Worker registration failed:', error);
    //             }
    //         });
    //     }
    // }, []);

    // const requestPermissionAndToken = async (messaging) => {
    //     try {
    //         const permission = await Notification.requestPermission();
    //         console.log('Notification permission:', permission);
    //         if (permission === 'granted') {
    //             const token = await getToken(messaging, {
    //                 vapidKey: 'BOHvaqn8B5wu7LPoBKss4wmNFnMhKpv-F-doypezBe88-py9gud7MunfBhrfxVz9R-tDOQcX6xaRLGRnlnfI6NE',
    //             });

    //             if (token) {
    //                 console.log('FCM Token:', token);
    //                 const res = await LeadService.deviceTokenFirebase(token);
    //                 if (res.data.success) {
    //                     console.info(res.data.message);
    //                     setFirebseToken(res.data.data);
    //                     // setOpen(true);
    //                 } else {
    //                     toast.error(res.data.message);
    //                 }
    //             } else {
    //                 console.warn('Token retrieval failed, retrying...');
    //                 setTimeout(() => requestPermissionAndToken(messaging), 5000); // Retry
    //             }
    //         } else {
    //             toast.error('Notification permission denied');
    //         }
    //     } catch (error) {
    //         console.error('Error retrieving token:', error);
    //         toast.error(error.message);
    //     }
    // };

    // Handle foreground notifications
    // onMessage(messaging, (payload) => {
    //     console.log('Foreground message received1213:', payload);
    //     debugger;
    //     if (payload.data) {
    //         setCallPayload(payload?.data);
    //         setOpen(false);
    //         if (payload?.data?.type === 'decline_call') {
    //             setOpen(false);
    //         }
    //     }
    //     if (payload.notification) {
    //         const { title, body } = payload.notification;
    //         // Display Toast Notification
    //         // toast.custom(
    //         //     (t) => (
    //         //         <div className={`custom-toast ${t.visible ? 'show' : 'hide'}`}>
    //         //             <button onClick={() => toast.dismiss(t.id)} className="toast-close-button">
    //         //                 ✕
    //         //             </button>
    //         //             <div className="toast-content">
    //         //                 <div className="toast-avatar">
    //         //                     <img src={logoImage} alt="User Avatar" />
    //         //                 </div>
    //         //                 <div className="toast-body">
    //         //                     <p className="toast-title">{title}</p>
    //         //                     <p className="toast-message">{body}</p>
    //         //                 </div>
    //         //             </div>
    //         //             <hr className="toast-divider" />
    //         //         </div>
    //         //     ),
    //         //     {
    //         //         duration: 1000, // Toast will auto-dismiss after 2000ms (2 seconds)
    //         //     }
    //         // );
    //     }
    //     const { title, body } = payload.notification;
    //     new Notification(title, { body });
    // });

    const bioText = getAgentData?.bio || '';
    const shortBio = bioText.slice(0, 300);
    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };

    if (loading) {
        // Render loading spinner
        return (
            <Grid container justifyContent="center" alignItems="center" style={{
                minHeight: '100vh', backgroundColor: '#dadada',
                backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0.53)), url(${heroBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat', padding: '16px'
            }}>
                <CircularProgress size={60} color="primary" />
            </Grid>
        );
    }

    if (success === false) {
        // Render "Page Not Found" UI
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh', backgroundColor: '#f5f5f5', padding: '16px' }}>
                <Grid item xs={12} sm={10} md={8} lg={6}>
                    <Card
                        sx={{
                            textAlign: 'center',
                            borderRadius: '12px',
                            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                            padding: '32px',
                        }}
                    >
                        <Typography variant="h3" color="primary" gutterBottom>
                            404
                        </Typography>
                        <Typography variant="h5" gutterBottom>
                            Oops! Page Not Found
                        </Typography>
                        <Typography variant="body1" color="textSecondary" paragraph>
                            The user profile you are looking for doesn't exist or has been removed.
                        </Typography>

                        {/* <Button
              variant="contained"
              color="primary"
              href="/"
              sx={{ marginTop: '16px', padding: '12px 24px' }}
            >
              Go Back to Home
            </Button> */}
                    </Card>
                </Grid>
            </Grid>
        );
    }
    if (success === true && getAgentData?.user_type === 'customer') {
        // Render "Page Not Found" UI
        return (
            <Grid container justifyContent="center" alignItems="center" style={{
                minHeight: '100vh', backgroundColor: '#dadada',
                backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0.53)), url(${heroBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat', padding: '16px'
            }}>
                <Grid item xs={12} sm={10} md={8} lg={6}>
                    <Card
                        sx={{
                            textAlign: 'center',
                            borderRadius: '12px',
                            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                            padding: '32px',
                        }}
                    >
                        <Typography variant="h3" color="primary" gutterBottom>
                            404
                        </Typography>
                        <Typography variant="h5" gutterBottom>
                            Oops! Page Not Found
                        </Typography>
                        <Typography variant="body1" color="textSecondary" paragraph>
                            The user profile you are looking for doesn't exist or has been removed.
                        </Typography>

                        {/* <Button
              variant="contained"
              color="primary"
              href="/"
              sx={{ marginTop: '16px', padding: '12px 24px' }}
            >
              Go Back to Home
            </Button> */}
                    </Card>
                </Grid>
            </Grid>
        );
    }

    // Render User Profile Card if success === true
    return success ? (
        <>
            <Grid
                container
                style={{
                    height: '100vh',
                    backgroundColor: '#dadada',
                    backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0.53)), url(${heroBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            >

                <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid item xs={12} sm={8} md={6} lg={4}>
                        <Card
                            sx={{
                                borderRadius: '12px',
                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                            }}
                        >
                            <CardContent>
                                <img
                                    src={logoAgent}
                                    alt="Logo"
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        maxWidth: '350px',
                                        margin: '0 auto 16px',
                                        display: 'block',
                                    }}
                                />
                                <Grid container direction="column" alignItems="center">
                                    <Avatar
                                        src={`https://iconnctapp.com/` + getAgentData?.profile_image}
                                        alt={getAgentData?.name}
                                        sx={{
                                            width: '130px',
                                            height: '130px',
                                            marginBottom: 2,
                                        }}
                                    />
                                    <Typography variant="h6" gutterBottom>
                                        {getAgentData?.name} {getAgentData?.last_name}
                                    </Typography>
                                    <Typography variant="body1" color="textSecondary" gutterBottom>
                                        📧 {getAgentData?.email}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" gutterBottom>
                                        📱{getAgentData?.phone}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        style={{
                                            height: '100px',
                                            overflowY: 'auto',
                                            marginBottom: '16px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        <span>
                                            {isExpanded ? bioText : shortBio}
                                            {isExpanded ? ' ' : '... '}
                                        </span>
                                        <span style={{ color: '#000', fontWeight: 'bold', cursor: 'pointer' }} onClick={handleToggle}>
                                            {isExpanded ? 'Show Less' : 'Show More'}
                                        </span>
                                    </Typography>
                                </Grid>
                            </CardContent>
                            {/* {getAgentData?.subscription_type === 'founder' ? (
                                <Typography
                                    variant="body2"
                                    style={{
                                        height: 'auto',
                                        overflowY: 'auto',
                                        marginBottom: '16px',
                                        textAlign: 'center',
                                        padding: '10px',
                                    }}
                                >
                                    <span style={{ fontWeight: 'bold' }}>Just a heads up:</span> The following feature in iConnct App are tied to only
                                    Elite
                                    <span style={{ fontWeight: 'bold' }}> ($199 per month)</span> and Premier{' '}
                                    <span style={{ fontWeight: 'bold' }}> ($99 per month)</span> subscription levels. &nbsp;
                                    <a href="https://iconnct.com/affiliate-program/" target="_blank" rel="noopener noreferrer">
                                        Check out your plan{' '}
                                    </a>
                                    to see what’s available to you. Thanks for being with us!
                                </Typography>
                            ) : ( */}
                                <>
                                    {getAgentData?.user_type === 'agent' && (
                                        <CardActions>
                                            {/* {isMobile ? ( */}
                                            {/* <Button
                                                    variant="contained"
                                                    color="primary"
                                                    fullWidth
                                                    sx={{
                                                        borderRadius: '12px',
                                                        padding: '12px',
                                                        margin: '12px',
                                                    }}
                                                    onClick={handleClickOpenApp}
                                                >
                                                    Open App 📱
                                                </Button> */}
                                            {/* ) : ( */}
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                fullWidth
                                                sx={{
                                                    borderRadius: '12px',
                                                    padding: '12px',
                                                    margin: '12px',
                                                }}
                                                onClick={() => handleClickCall(getAgentData?.id)}
                                                disabled={loadingButton}
                                            >
                                                {loadingButton ? 'Calling...' : '📞 Call Now'}
                                            </Button>
                                            {/* )} */}
                                        </CardActions>
                                    )}
                                </>
                            {/* )} */}
                        </Card>
                    </Grid>
                </Grid>
            </Grid>
            {/* Name Modal */}
            <Modal open={nameModal} aria-labelledby="modal-title" aria-describedby="modal-description" closeAfterTransition>
                <Fade in={nameModal} timeout={250}>
                    <Box sx={modalStyle}>
                        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography id="modal-title" variant="h6" component="h2">
                                Enter Name
                            </Typography>
                            <Typography id="modal-title" variant="h6" component="h2" style={{ cursor: 'pointer' }} onClick={handleCloseModal}>
                                <CancelIcon />
                            </Typography>
                        </Box>


                        <Box component="form" mt={2}>
                            <TextField
                                label="First Name"
                                variant="outlined"
                                fullWidth
                                required
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                inputProps={{ maxLength: 100 }}
                                sx={{
                                    mb: 2,
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                            <TextField
                                label="Last Name"
                                variant="outlined"
                                fullWidth
                                required
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                inputProps={{ maxLength: 100 }}
                                sx={{
                                    mb: 2,
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />

                            <Button
                                variant="contained"
                                color="primary"
                                onClick={HandleCreateAgentCustomer}
                                fullWidth
                                sx={{ borderRadius: '12px' }}
                                disabled={loadingSaving}
                            >
                                {loadingSaving ? 'Connecting...' : 'Connect'}
                            </Button>
                        </Box>
                    </Box>
                </Fade>
            </Modal>

            <VideoCallModal
                open={open}
                setOpen={setOpen}
                getAgentData={getAgentData}
                callPayload={callPayload}
                variable={variable}
                agentDetails={agentDetails}
                setAgentDetails={setAgentDetails}
                firstName={firstName}
                lastName={lastName}
                setFirstName={setFirstName}
                setLastName={setLastName}
                setLoadingButton={setLoadingButton}
            />
        </>
    ) : null;
};

export default UserProfileCard;
